import { useAuth0 } from "@/Contexts";
import { Translate, useTrans } from "@/translations";

import { MouseEvent } from "react";

export const Unauthorized = () => {
  const { t } = useTrans();
  const { logout } = useAuth0()!;

  const onLogout = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="bg-grey1 fixed top-0 right-0 bottom-0 left-0 z-30 flex flex-col items-center justify-center">
      <h1 className="font-signifier w-[920px] text-center text-3xl">
        <Translate
          i18nKey={"errors:unauthorized"}
          components={[
            // Anchor content is added by the translation
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              href="mailto:support@carrot.tech"
              className="text-fucales underline"
            />,
          ]}
        />
      </h1>
      <a
        className="text-fucales mt-6 cursor-pointer text-3xl underline"
        href="/"
        onClick={onLogout}
      >
        {t("actions:logout")}
      </a>
    </div>
  );
};

export default Unauthorized;
